/* A standalone frame (logo, soft wash, centred card) for pages shown outside the shell: 404 and crashes. */
import type { ReactNode } from 'react'
import { LogoLockup } from '@/components/shell/Logo'

export function SystemFrame({ children }: { children: ReactNode }) {
  return (
    <div className="relative isolate flex min-h-dvh flex-col items-center bg-app-canvas px-4">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[30rem] hero-wash [mask-image:linear-gradient(to_bottom,black,transparent)] opacity-80"
      />
      <a href="/" className="mt-10 rounded-lg">
        <LogoLockup className="h-[24px] w-auto" />
      </a>
      <main
        id="main"
        className="flex w-full max-w-lg flex-1 flex-col items-center justify-center pb-24 text-center"
      >
        {children}
      </main>
    </div>
  )
}
